module.exports = __webpack_public_path__ + "img/Alex.d0b63a16.jpg";